export default __webpack_public_path__ + "static/media/brewing-thumb.ec85308d.jpg";